module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_start_guanghuan.c6811.png";